import {ListGoalBasic_goals} from '../../../schema-types/ListGoalBasic';
import {ListGoals_goals} from '../../../schema-types/ListGoals';

export const datagridSorter = (a: ListGoals_goals, b: ListGoals_goals): number => {
  if (!a.priority || a.priority === 'N/A') {
    return 1;
  }
  if (!b.priority || b.priority === 'N/A') {
    return -1;
  }
  const parsedPriorityA = parseInt(a.priority, 10);
  const parsedPriorityB = parseInt(b.priority, 10);

  if (parsedPriorityA === parsedPriorityB) {
    return a.targetEndDate > b.targetEndDate ? 1 : -1;
  }
  return parsedPriorityA - parsedPriorityB;
};

export const getGoalName = (value: ListGoalBasic_goals | null | undefined) =>
  value?.name || 'Unnamed Goal';
